// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/order/index.raw').LWApiPublicOrderListParamsRaw} params
 * @param {import('@tanstack/react-query').UseQueryOptions<import('club-sauce/public/order/index.raw').LWApiPublicOrderListResultRaw>} [options]
 */
const useOrderList = (params, options) =>
	useQuery({
		queryKey: ['/order/list', params],
		queryFn: () => api.order.apiRaw.list(params),
		...options,
	});

export default useOrderList;
